module.exports = __webpack_public_path__ + "static/media/electricista.5d9ae849.jpg";